import assign = require('object-assign');
import * as fetch from 'superagent';

interface IFetchConfig {
    method: string,
    body?: Object,
    query?: Object,
    headers?: Object,
}

let defaultFactory: RequestFactory;

export class RequestFactory {
    private apiKey: string;

    constructor(private baseUrl: string) { }

    setApiKey(apiKey: string) {
        this.apiKey = apiKey;
        // console.log('using apiKey', apiKey);
    }

    fetch(url: string, config?: IFetchConfig) {
        if (url.indexOf('http://') < 0 && url.indexOf('https://') < 0) {
            url = [this.baseUrl, url].join('/');
        }

        const obj = assign({}, config);
        const request = fetch(obj.method, url);

        request.withCredentials();

        if (obj.body) {
            request.send(obj.body);
        }

        if (obj.query) {
            request.query(obj.query);
        }

        if (this.apiKey) {
            request.query({ apiKey: this.apiKey });
        }

        return request.then(response => response.body, err => { throw err; });
    }

    get(url: string, query, config?: IFetchConfig) {
        config = assign({}, config, {
            method: 'GET',
            query: query
        });

        return this.fetch(url, config);
    }

    post(url: string, body, config?: IFetchConfig) {
        config = assign({}, config, {
            method: 'POST',
            body: body
        });

        return this.fetch(url, config);
    }

    put(url: string, body, config?: IFetchConfig) {
        config = assign({}, config, {
            method: 'PUT',
            body: body
        });

        return this.fetch(url, config);
    }

    del(url: string, config?: IFetchConfig) {
        config = assign({}, config, {
            method: 'DELETE'
        });

        return this.fetch(url, config);
    }
}

export function setDefaultFactory(factory: RequestFactory) {
    defaultFactory = factory;
}

export { defaultFactory };


// WEBPACK FOOTER //
// ./src/api/RequestFactory.ts